import { selectedCustomer } from '@app/ngrx-customer/store';
import { createSelector } from '@ngrx/store';
import { productDetailsViewModelSelector } from '@product-detail/selectors/product-detail.selector';
import { ProductFilter } from '@shared/helpers/product-filter.helpers';
import { selectOnline } from '@panamax/app-state';
import { ImageVariantEnum } from '@product-detail/models/image-variant.enum';
import { getFirstImageURL } from '@product-detail/utils/product-images.util';
import { UsfProductCardModeEnum } from '@shared/constants/usf-product-card-mode.enum';
import { ProductCardModelHelper } from '@shared/helpers/product-card-model-helper.service';
import { orderItemSelectors } from '@usf/ngrx-order';

export const coveoTopSellersViewModelSelector = (productNumbers: number[]) =>
  createSelector(
    productDetailsViewModelSelector(productNumbers),
    selectedCustomer,
    (productDetails, selectedCustomer) => {
      return Array.from(productDetails?.values() ?? []).filter(
        product =>
          !!product &&
          ProductFilter.productPassesOgRestrictions(product, selectedCustomer),
      );
    },
  );

export const coveoTopSellersDyfViewModelSelector = (productNumbers: number[]) =>
  createSelector(
    coveoTopSellersViewModelSelector(productNumbers),
    orderItemSelectors.selectOrderItemState,
    selectOnline(),
    (products, orderItemState, online) => {
      return products.map(product => {
        return {
          product,
          productCardVM: ProductCardModelHelper.create(
            product,
            orderItemState,
            online,
            selectedCustomer,
            UsfProductCardModeEnum.topSeller,
          ),
        };
      });
    },
  );
